import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Landing } from "@/pages/Landing";
import { Room } from "@/pages/Room";
import { useMe } from "@/hooks/useMe";

export function App() {
  const { me, setMe } = useMe();

  return (
    <BrowserRouter>
      <div className="flex min-h-screen flex-col">
        <Header me={me} onMeChange={setMe} />
        <Routes>
          <Route path="/" element={<Landing me={me} onMeChange={setMe} />} />
          <Route path="/r/:code" element={<Room me={me} onMeChange={setMe} />} />
          <Route
            path="*"
            element={
              <main className="container flex flex-1 items-center justify-center py-10">
                <p className="text-muted-foreground">Page not found.</p>
              </main>
            }
          />
        </Routes>
      </div>
      <Toaster richColors theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}
